import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const name = <FormattedMessage {...messages.nameColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.nameColumnHeader,
  name,
  render: (data) => data.name || '',
};
